export const changeLoading = ( { commit }, payload ) => {
    commit('updateLoading', payload);
}

export const changeSelectedUser = ( { commit }, payload ) => {
    commit('updateSelectedUser', payload);
}